// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__j0ZY7","loader":"Loader_loader__MpAf7","left":"Loader_left__OnHwc","right":"Loader_right__Dfdon"};